import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/wave.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/download.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/player.svg';
export default {
  name: 'ProductMedia',
  props: {
    dangerousProduct: {
      type: String,
      default: ''
    },
    dangerousProductTranslated: {
      type: String,
      default: ''
    },
    specificityLogo: {
      type: Object || null,
      required: true
    }
  },

  data() {
    return {
      isPlaying: false,
      imagesPath: 'https://cdn.maisonsdumonde.com/images/segmentations/'
    };
  },

  methods: {
    labels_logos(labels) {
      return Object.values(labels).filter(label => label.description);
    }

  }
};